import React from 'react'
import { graphql } from 'gatsby'
import PageMeta from '../components/pageMeta'
import SiteWrapper from '../components/siteWrapper'

const Page = ({
  data: {
    wpPage: {
      title,
      content,
      pageMeta: { metadescription },
    },
  },
}) => (
  <SiteWrapper>
    <PageMeta title={title} description={metadescription} />
    <main className="py-16 md:py-24 lg:py-28">
      <div className="container-small container">
        <h1 className="page-title">{title}</h1>
        <PageMeta title={title} description={metadescription} />
        <div
          className="body-content wp-content mb-10"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      <div className="container">
        <iframe
          className="airtable-embed border"
          src="https://airtable.com/embed/apppfo8seb2mNDdxr/shr2iCXltwGl9dXVq"
          width="100%"
          height="1000"
        ></iframe>
      </div>
    </main>
  </SiteWrapper>
)

export const pageQuery = graphql`
  query StoryBankPageQuery {
    wpPage(slug: { eq: "storybank" }) {
      title
      content
      pageMeta {
        metadescription
      }
    }
  }
`

export default Page
